module.exports = __webpack_public_path__ + "static/volutes-left-01db5bed4d5b6bfdc7fef5ae6e86fc6c.svg";